module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Earth-bd636abafeb00fc57347b0ab81a761b2.svg";